module.exports = __webpack_public_path__ + "static/media/Send.517bfe6b.png";